import { ITEM_STATUS } from "./checklistTemplate";
import { countAvariasCriticas, normalizeAvarias } from "./avariaModel";

// Critério de avaliação combinado: itens do checklist marcados como
// "Crítico" + avarias/riscos externos marcados com gravidade "Crítica"
// (no diagrama do veículo ou em fotos reais). Usado por Dashboard,
// Relatórios e export PDF/HTML para que avarias entrem na contagem de
// itens críticos do checklist.
export function contarCriticosChecklist(checklist) {
  const itensCriticos = (checklist.itens || []).filter((i) => i.status === ITEM_STATUS.CRITICO).length;
  const avariasCriticas = countAvariasCriticas(normalizeAvarias(checklist.avarias));
  return itensCriticos + avariasCriticas;
}
